<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <base-page-layout ref="base-page" title="Histórico de consultas de gestão de ofertas" :hide-breadcrumbs="$getFirstValue()">
      <campaign-results-banner :campanha="campanha" />
      <mf-tabs-menu v-model="offersTypeTabHighLevel" :tabs="offersTypeTabsHighLevel" class="mt-4">
        <template v-slot:children>
          <mf-tabs-menu v-model="offersTypeTabLowLevel" :tabs="getSubTabTabs" class="mt-4" />
        </template>
      </mf-tabs-menu>
      <consumed-sales-table-history v-if="campanha" class="mt-4 mb-2" :campanha="campanha" :current-offer-type-key-name="currentOfferTypeKeyName" />
      <mf-action-buttons
        :primary-button="{
          text: 'Fechar',
          action: backToOffersList,
          isVisible: true,
          isLoading: false,
        }"
      />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ConsumedSalesTableHistory from '../components/ConsumedSalesTableHistory.vue'
import CampaignResultsBanner from '../components/CampaignResultsBanner.vue'
import { QUERY_SALES_CAMPAIGN_RESULTS_BY_ID } from '../../graphql'
import { offerSalesTabs } from '../mixins/offer-sales-tabs'
export default {
  name: 'Results',
  components: {
    BasePageLayout,
    ConsumedSalesTableHistory,
    CampaignResultsBanner,
  },
  mixins: [offerSalesTabs],
  data: () => ({
    campanha: {
      name: '',
      description: '',
      eans: [],
      start_date: '',
      end_date: '',
      offer_sales: [],
      active: false,
      segments: [],
      activatable: false,
      industry: null,
    },
  }),
  computed: {
    modules() {
      return this.$getAllowedModules()
    },
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
  },
  apollo: {
    campanha: {
      query: QUERY_SALES_CAMPAIGN_RESULTS_BY_ID,
      variables() {
        const { id } = this.$route.params
        const franchise = Boolean(this.$route.query.franchise)
        const data = { id }
        if (franchise) {
          data.franchise = franchise
        }
        return data
      },
      context() {
        return {
          uri: this.$microservicesUrls['sales'],
        }
      },
      update({ offerSchedule }) {
        return offerSchedule
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    },
  },
  methods: {
    backToOffersList() {
      let routeName = 'gestao-ofertas'
      if (this.campanha.industry) {
        routeName = 'ofertas-trade-propostas'
      }
      this.$router.push({ name: routeName }).catch(() => {})
    },
  },
}
</script>

<style lang="scss"></style>
